
// STOCK-LABO : écran d'un stock (Pharmacie, Laboratoire) — quantités et seuils d'alerte (modifiables par la
// Pharmacie), entrées, transferts, sorties.
export default {
    name: 'show-stock',
    components: {},
    props: [],
    data() {
        return {
            recherche_article: '',
            par_page: 10,
            pages: {},
            liste_entres: [
                { key: 'article', label: 'Article' }, { key: 'initial', label: 'Avant' }, { key: 'nombre', label: 'Nombre' },
                { key: 'fournisseur', label: 'Fournisseur' }, { key: 'date_peremption', label: 'Péremption' }, { key: 'date', label: 'Date' }
            ],
            liste_sorties: [
                { key: 'article', label: 'Article' }, { key: 'motif', label: 'Motif' }, { key: 'initial', label: 'Avant' },
                { key: 'nombre', label: 'Nombre' }, { key: 'date', label: 'Date' },
                { key: 'patient', label: 'Patient', formatter: value => value || 'Non renseigné' }
            ],
            liste_echanges: [
                { key: 'type', label: 'Sens' }, { key: 'stock', label: 'Autre stock' }, { key: 'article', label: 'Article' },
                { key: 'nombre', label: 'Nombre' }, { key: 'date', label: 'Date' }
            ],

            disponible: [
                { key: 'libelle', label: 'Article' }, { key: 'quantite', label: 'Quantité' }, { key: 'minimum', label: 'Seuil d\'alerte' }
            ],

            seuil_en_edition: null,     // id de l'article dont le seuil est en cours de saisie
            seuil_saisi: '',
            seuil_loading: false,
            seuil_erreur: ''
        }
    },
    computed: {
        stock() {
            return this.$store.getters['stock']
        },

        echanges() {
            return this.$store.getters['echanges'] || []
        },

        userCredentials() {
            return this.$store.getters['authInfo']
        },

        // Le magasin initialise `stock` à un tableau vide : les listes sont absentes tant que le stock n'est pas chargé.
        articles() {
            return (this.stock && this.stock.articles) ? this.stock.articles : []
        },

        groupes_articles() {
            const recherche = this.normaliserRecherche(this.recherche_article)
            const groupes = [
                { key: 'medicaments', titre: 'Médicaments', articles: [] },
                { key: 'consommables', titre: 'Consommables', articles: [] },
                { key: 'autres', titre: 'Autres articles', articles: [] }
            ]
            this.articles.forEach(article => {
                const type = String(article.type_article_id)
                groupes[type === '1' ? 0 : type === '2' ? 1 : 2].articles.push(article)
            })
            return groupes.filter(groupe => groupe.articles.length > 0).map(groupe => {
                const articles = groupe.articles.filter(article => this.normaliserRecherche(article.libelle).includes(recherche))
                    .slice().sort((a, b) => String(a.libelle || '').localeCompare(String(b.libelle || ''), 'fr', { numeric: true }))
                return Object.assign({ key: groupe.key, titre: groupe.titre, effectif: groupe.articles.length }, this.paginer(articles, groupe.key))
            })
        },

        cartes_historiques() {
            return [
                { key: 'entres', titre: 'Approvisionnements (entrées)', lignes: this.entres, champs: this.liste_entres },
                { key: 'echanges', titre: 'Transferts entre stocks', lignes: this.echanges, champs: this.liste_echanges },
                { key: 'sorties', titre: 'Sorties et consommations', lignes: this.sorties, champs: this.liste_sorties }
            ].map(carte => Object.assign({ key: carte.key, titre: carte.titre, champs: carte.champs }, this.paginer(carte.lignes, carte.key)))
        },

        est_magasin_central() {
            return this.stock && this.stock.code === 'magasin-central'
        },

        entres() {
            return (this.stock && this.stock.entres) ? this.stock.entres : []
        },

        sorties() {
            return (this.stock && this.stock.sorties) ? this.stock.sorties : []
        },

        /** Le seuil d'alerte d'un article dans ce stock se fixe à la Pharmacie (administrateur ou pharmacien). */
        peut_modifier_seuil() {
            const roles = (this.userCredentials && this.userCredentials.user && this.userCredentials.user.roles) ? this.userCredentials.user.roles : []
            return roles.some(role => role.nom === 'ROLE_ADMINISTRATEUR' || role.nom === 'ROLE_PHARMACIEN' || role.nom === 'ROLE_RESPONSABLE_LOGISTIQUE')
        },
    },
    watch: {
        recherche_article() {
            this.pages = Object.assign({}, this.pages, { medicaments: 1, consommables: 1, autres: 1 })
        },
        par_page() { this.pages = {} },
        '$route.params.id'() {
            this.recherche_article = ''
            this.pages = {}
            this.annulerSeuil()
            this.chargerStock()
        }
    },
    mounted() {
        this.chargerStock()
    },
    methods: {
        chargerStock() {
            this.$store.dispatch('getStock', this.$route.params.id)
            this.$store.dispatch('getEchanges', this.$route.params.id)
        },

        normaliserRecherche(valeur) {
            return String(valeur || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
        },

        paginer(lignes, key) {
            const taille = Number(this.par_page)
            const total = lignes.length
            const derniere = Math.max(1, Math.ceil(total / taille))
            const page = Math.min(derniere, Math.max(1, Number(this.pages[key]) || 1))
            const debut = (page - 1) * taille
            return { page, total, debut: total ? debut + 1 : 0, fin: Math.min(debut + taille, total), items: lignes.slice(debut, debut + taille) }
        },

        changerPage(key, page) {
            this.pages = Object.assign({}, this.pages, { [key]: page })
        },

        /** Classe de la quantité : rupture (0), sous le seuil du stock, ou normale. */
        etatQuantite(ligne) {
            const quantite = Number(ligne.quantite) || 0
            const seuil = Number(ligne.minimum) || 0
            if (quantite <= 0) return 'text-danger font-wgh-600'
            if (seuil > 0 && quantite <= seuil) return 'text-warning font-wgh-600'
            return ''
        },

        editerSeuil(ligne) {
            this.seuil_en_edition = ligne.id
            this.seuil_saisi = ligne.minimum !== null && ligne.minimum !== undefined ? String(ligne.minimum) : ''
            this.seuil_erreur = ''
        },

        annulerSeuil() {
            this.seuil_en_edition = null
            this.seuil_saisi = ''
            this.seuil_erreur = ''
        },

        async enregistrerSeuil(ligne) {
            const seuil = parseInt(this.seuil_saisi, 10)
            if (isNaN(seuil) || seuil < 0) {
                this.seuil_erreur = 'Le seuil doit être un nombre entier positif ou nul.'
                return
            }
            this.seuil_loading = true
            this.seuil_erreur = ''
            try {
                await this.$store.dispatch('saveSeuilStock', { id: this.stock.id, data: [{ article: ligne.id, minimum: seuil }] })
                this.seuil_en_edition = null
                this.seuil_saisi = ''
            } catch (e) {
                this.seuil_erreur = 'Le seuil n\'a pas pu être enregistré.'
            }
            this.seuil_loading = false
        }
    }
}
